import React from "react"
import {Route, Routes} from "react-router-dom"
import {Profile} from "../../pages/Profile"

export const ProfileRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Profile/>}></Route>
      <Route path="/:orbitId/:profilePk" element={<Profile/>}></Route>
    </Routes>
  )
}
